import { render } from "./CollectionView.vue?vue&type=template&id=67da08c4&scoped=true"
import script from "./CollectionView.vue?vue&type=script&lang=js"
export * from "./CollectionView.vue?vue&type=script&lang=js"

import "./CollectionView.vue?vue&type=style&index=0&id=67da08c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67da08c4"]])

export default __exports__